import React, { useContext, useState } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  Image,
  Row,
  Spinner,
} from "react-bootstrap";
import { ImageDevices, LogoBundar } from "../../assets/images/image";
import Swal from "sweetalert2";
import AuthContext from "../../auth/Context/AuthContext";
import axios from "../../adapters/API/axios";
import { useNavigate } from "react-router-dom";
import { AiFillEyeInvisible, AiFillEye } from "react-icons/ai";
import instance from "../../adapters/API/axios";
import ModalLupaPassword from "../../component/Modal/ModalLupaPassword";
import Cookies from "js-cookie";

function Login() {
  const [username, setUser] = useState("");
  const [isTestingApi, setIsTestingApi] = useState(false);
  const [password, setPwd] = useState("");
  const { setTokens, setUserInfo, setGroups } = useContext(AuthContext);
  const [disabled, setDisabled] = useState(false);
  const [isSubmittingLogin, setIsSubmittingLogin] = useState(false);
  const navigate = useNavigate();
  const [passwordShown, setPasswordShown] = useState(false);
  const togglePassword = () => {
    setPasswordShown(!passwordShown);
  };
  const [showLupaPassword, setShowLupaPassword] = useState(false);
  const handleShowLupaPassword = () => {
    setShowLupaPassword(true);
  };

  const win = window.sessionStorage;
  const handleSubmitLogin = async (event) => {
    event.preventDefault();
    setIsSubmittingLogin(true);
    setDisabled(true);

    const data = {
      username: username,
      password: password,
    };
    try {
      const response = await axios.post(`/api/login/`, data, {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          withCredentials: true,
        },
        httpsAgent: {
          rejectUnauthorized: false,
        },
      });

      const userInfo = response?.data.user;
      const userToken = response?.data;
      const userGroups = response?.data.groups;
      setTokens({ token: userToken.token });
      win.setItem("token", JSON.stringify({ token: userToken.token }));
      setUserInfo(userInfo);
      win.setItem("userInfo", JSON.stringify(userInfo));
      setGroups(userGroups);
      win.setItem("groups", JSON.stringify(userGroups));

      Swal.fire({
        icon: "success",
        title: "Login berhasil",
        showConfirmButton: false,
        timer: 2000,
      });
      setIsSubmittingLogin(false);
      setDisabled(false);
      navigate("/home");
    } catch (err) {
      console.error(err);

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Server tidak ada respon",
      });
      setIsSubmittingLogin(false);
      setDisabled(false);

      if (!err?.response) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Server tidak ada respon",
        });
        setIsSubmittingLogin(false);
        setDisabled(false);
      } else if (err.response?.status === 400) {
        Swal.fire({
          icon: "error",
          title: "Oops...!",
          text: `${err.response?.data.non_field_errors}`,
        });
        setIsSubmittingLogin(false);
        setDisabled(false);
      } else if (err.response?.status === 401) {
        Swal.fire({
          icon: "error",
          title: "Oops...!",
          text: `Periksa kembali Username dan Password anda`,
        });
        setIsSubmittingLogin(false);
        setDisabled(false);
      }
    }
  };

  const handleTestApiLuar = async () => {
    setIsTestingApi(true);

    try {
      const response = await axios.get(
        "https://jsonplaceholder.typicode.com/posts/1",
        {
          timeout: 10000,
        },
      );

      // Mencegah data HTML dari respons dijalankan di dalam popup
      const formattedData = JSON.stringify(response.data, null, 2)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");

      Swal.fire({
        icon: "success",
        title: "Berhasil mendapatkan data",
        width: 700,
        html: `
                <pre style="
                    text-align: left;
                    max-height: 350px;
                    overflow: auto;
                    white-space: pre-wrap;
                    background: #f5f5f5;
                    padding: 15px;
                    border-radius: 8px;
                    font-size: 13px;
                ">${formattedData}</pre>
            `,
        confirmButtonText: "Tutup",
      });

      console.log("Data API luar:", response.data);
    } catch (err) {
      console.error("Gagal mengakses API luar:", err);

      const errorMessage =
        err.response?.data?.message ||
        err.response?.data?.detail ||
        err.message ||
        "API tidak memberikan respons";

      Swal.fire({
        icon: "error",
        title: "Data tidak dapat diperoleh",
        text: errorMessage,
        confirmButtonText: "Tutup",
      });
    } finally {
      setIsTestingApi(false);
    }
  };

  return (
    <Container
      fluid
      className="vh-100 d-flex align-items-center justify-content-center"
    >
      <div id="cardLogin" className="text-center my-5">
        <Row>
          <Col xs={12} md={7} lg={7} className="text-center">
            <div className="text-start">
              <Image
                onClick={handleTestApiLuar}
                src={LogoBundar}
                fluid
                width={100}
              />
            </div>
            <h4 className="my-4 mx-4" style={{ fontFamily: "Poppins-Medium" }}>
              Selamat datang di Aplikasi Absensi kami!
            </h4>
            <div className="mb-5 text-center mx-4">
              <Image src={ImageDevices} fluid width={500} />
            </div>
          </Col>
          <Col xs={12} md={5} lg={5} className="text-start my-auto">
            <div className="mx-4">
              <p
                className="text-center mb-5"
                style={{ fontFamily: "Poppins-Light" }}
              >
                Silahkan Login menggunakan Akun yang sudah dibuat!
              </p>
              <Form onSubmit={handleSubmitLogin}>
                <Form.Group className="mb-3">
                  <Form.Label style={formStyles.label} htmlFor="usernameLogin">
                    Username*
                  </Form.Label>
                  <Form.Control
                    id="username"
                    type="text"
                    disabled={disabled}
                    onChange={(e) => setUser(e.target.value)}
                    value={username}
                    required
                    placeholder="Masukkan username anda"
                    style={formStyles.input}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label style={formStyles.label} htmlFor="passwordLogin">
                    Password*
                  </Form.Label>
                  <Form.Control
                    id="password"
                    type={passwordShown ? "text" : "password"}
                    disabled={disabled}
                    onChange={(e) => setPwd(e.target.value)}
                    value={password}
                    required
                    placeholder="Masukkan password anda"
                    style={formStyles.input}
                  />
                  <p
                    className="mt-2"
                    onClick={togglePassword}
                    style={{
                      fontFamily: "Poppins-Regular",
                      cursor: "pointer",
                      maxWidth: "150px",
                    }}
                  >
                    {passwordShown ? "Hide" : "Show"} password{" "}
                    <span>
                      {passwordShown ? (
                        <AiFillEyeInvisible />
                      ) : (
                        <AiFillEye />
                      )}{" "}
                    </span>
                  </p>
                </Form.Group>
                <div>
                  <p
                    className="mt-4"
                    onClick={handleShowLupaPassword}
                    style={{
                      fontFamily: "Poppins-Regular",
                      cursor: "pointer",
                      textDecoration: "underline",
                      color: "#12B3ED",
                    }}
                  >
                    Lupa password?
                  </p>
                </div>
                <div className="d-grid gap-2 my-4">
                  {isSubmittingLogin ? (
                    <Button
                      type="submit"
                      // id='actionButtonLogin'
                      variant="btn"
                      disabled={disabled}
                      style={{
                        backgroundColor: "#12B3ED",
                        color: "#FFFFFF",
                      }}
                    >
                      <Spinner
                        animation="border"
                        size="sm"
                        style={{ color: "#FFFFFF" }}
                      />
                    </Button>
                  ) : (
                    <Button
                      type="submit"
                      id="actionButtonLogin"
                      variant="primary"
                      disabled={disabled}
                    >
                      Masuk
                    </Button>
                  )}
                </div>
              </Form>
            </div>
            {/* <div className="d-grid gap-2 mb-4">
              <Button
                type="button"
                style={{ margin: "20px" }}
                variant="warning"
                onClick={handleTestApiLuar}
                disabled={isTestingApi}
              >
                {isTestingApi ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Mengambil data...
                  </>
                ) : (
                  "Test API Luar"
                )}
              </Button>
            </div> */}
          </Col>
        </Row>
      </div>

      <ModalLupaPassword
        showLupaPassword={showLupaPassword}
        setShowLupaPassword={setShowLupaPassword}
      />
    </Container>
  );
}

export default Login;

const formStyles = {
  label: {
    fontFamily: "Poppins-Medium",
    color: "white",
  },
  input: {
    color: "#222",
    fontFamily: "Poppins-Regular",
    minHeight: "50px",
    borderColor: "#ced4da", // Initial border color
  },
};
